import React from 'react';
import PropTypes from 'prop-types';
import QRCode from 'react-qr-code';
import FacilitatorLayout from '@/components/FacilitatorLayout';

const FacilitatorAssessmentSessionQRCode = ({ sessionId, applicationUrl, assessmentTitle, currentUser }) => {
  const baseUrl = applicationUrl || window.location.origin;
  const assessmentUrl = `${baseUrl}/?code=${sessionId}`;
  const title = assessmentTitle || 'Change Success Assessment';
  
  return (
    <FacilitatorLayout userName={currentUser?.name || 'Facilitator'}>
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-8rem)] p-8">
        <div className="max-w-md mx-auto text-center">
          <h1 className="text-3xl mb-8">{title}</h1>
          
          <div className="w-64 h-64 mx-auto flex items-center justify-center bg-card border rounded p-2 mb-6">
            <QRCode value={assessmentUrl} size={240} />
          </div>
          
          <p className="mt-6 text-lg">
            Scan this QR code to start the assessment,<br /> or go to {baseUrl} and enter the code:
          </p>
          <p className="font-mono font-bold text-xl mt-2">{sessionId}</p>
        </div>
      </div>
    </FacilitatorLayout>
  );
};

FacilitatorAssessmentSessionQRCode.propTypes = {
  sessionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  applicationUrl: PropTypes.string,
  assessmentTitle: PropTypes.string,
  currentUser: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string
  })
};

export default FacilitatorAssessmentSessionQRCode; 